<template>
      <div class="box">
        <el-container>
            <el-header style="text-align: right; font-size: 12px">

              <el-dropdown @command="handleCommand">
                <span>{{ loginName }} {{ customerName }}</span>
                <!-- <span v-if="customerType == 8">{{ loginName }} 商户运营</span>
                <span v-if="customerType == 7">{{ loginName }} 店铺运营</span> -->
                <i class="el-icon-setting" style="margin-right: 15px"></i>
                <el-dropdown-menu slot="dropdown">

                  <el-dropdown-item command="1">修改密码</el-dropdown-item>
                  <el-dropdown-item v-if="customerType == 6" command="3">权限设置</el-dropdown-item>
                  <el-dropdown-item command="2">退出登录</el-dropdown-item>

                </el-dropdown-menu>
              </el-dropdown>

            </el-header>
          </el-container>
          <el-dialog width="50%" title="修改密码" :destroy-on-close="true" :before-close="beforeClose" :visible.sync="dialogTableVisible">
            <div class="date_box">
                <el-form :inline="false" label-width="130px" :model="formInline" :rules="rules" ref="formInline" class="demo-form-inline">
                  <el-form-item label="登录名" prop="loginName">
                        <el-input v-model="formInline.loginName" disabled placeholder="登录名"></el-input>
                    </el-form-item>
                  <el-form-item label="旧密码" prop="oldloginpwd">
                        <el-input type="password" v-model="formInline.oldloginpwd" placeholder="旧密码"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="loginpwd">
                        <el-input type="password" v-model="formInline.loginpwd" placeholder="新密码"></el-input>
                    </el-form-item>
                    <el-form-item  style="display: block; text-align: right;">
                        <el-button type="primary" @click="onSubMitData('formInline')">保存数据</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
        <el-dialog width="30%" title="权限管理" :destroy-on-close="true" :before-close="beforeClose" :visible.sync="dialogTableVisible1">
            <div class="date_box">
                <el-form label-width="130px" :model="formInline" :rules="rules" ref="formInline" class="demo-form-inline">
                    <el-form-item label="权限类型">
                        <el-select   @change="changeSelect" v-model="shopUserGuid" clearable placeholder="权限类型">
                            <el-option label="商户" value=""></el-option>
                            <!-- <el-option  v-for="item in shopUserArr" :key="item.id" :label="item.trueName" :value="item.userGuid"></el-option> -->
                        </el-select>
                    </el-form-item>
                    <el-tree
                        :data="treeListData"
                        show-checkbox
                        default-expand-all
                        node-key="guid"
                        ref="tree"
                        highlight-current
                        :props="defaultProps">
                    </el-tree>
                    <el-form-item  style="display: block; text-align: right;">
                        <el-button type="primary" @click="onSubMitData1('formInline')">保存数据</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
      </div>
</template>

<script>
import userApi from '../api/login.js';
import authorityApi from '../api/authority/authority';
import orgStaffApi from '../api/orgStaffManage/orgStaff';
import { Message } from 'element-ui'
import { mapGetters } from 'vuex'
  export default{
    name: 'headNav',
    data(){

      return{
        customerType: sessionStorage.getItem("customerType"),
        customerName: '',
        dialogTableVisible: false,
        dialogTableVisible1: false,
        shopUserArr: [],
        treeListData: [],
        selectTreeListData: [],
        loginName: sessionStorage.getItem("loginName"),
        shopUserGuid: '',
        defaultProps: {
          children: 'children',
          label: 'permissionName'
        },
        formInline:{
          oldloginpwd: '',
          loginpwd: '',
          loginName: ''
        },
        rules: {
            oldloginpwd: [
                  { required: true, message: '旧密码不能为空', trigger: 'blur' }
            ],
            loginpwd: [
                  { required: true, message: '新密码不能为空', trigger: 'blur' }
            ]
        }
      }
    },
    computed: {
    ...mapGetters([
      'name',
      'avatar'
    ])
  },
    created(){
      // console.log()
      if(this.customerType == 6){
        this.customerName = '商户管理'
      }else if(this.customerType == 7){
         this.customerName = '店铺运营'
      }else if(this.customerType == 8){
         this.customerName = '商户运营'
      }
    },
    methods: {
      beforeClose(){
        this.dialogTableVisible = false;
        this.dialogTableVisible1 = false;
      },
      handleCommand(e){
        if(e == 3){
            this.shopUserGuid = '';
            // this.queryBusShopUserVoBypage();
            this.querySystemPermssionByRoleType();
        }else if(e == 2){
          this.$store.dispatch('user/LogOut', {}).then(() => {
            this.$router.push({path: '/login'})
          });
        }else{
          this.dialogTableVisible = true;
          // console.log(this.loginName)
          this.formInline = {
            oldloginpwd: '',
            loginpwd: '',
            loginName: this.loginName,
            guid: sessionStorage.getItem("userGuid")
          }
        }
        // console.log(e)
      },
      onSubMitData1(formName){
        let _this = this;
        this.addBusUserPermMapList();

      },
      querySystemPermssionByRoleType7(){
        authorityApi.querySystemPermssionByRoleType7({
          shopUserGuid: this.shopUserGuid
        }).then(res =>{
          // console.log(res)
                if(res.code == 0){
                 this.treeListData = res.data;
                 this.selectTreeListData = [];
                  this.forEachList(res.data);
                  this.setCheckedNodes(this.selectTreeListData);
                  this.queryBusShopUserVoBypage();
                }else if(res.msg == '查询数据为空！'){
                  this.$refs.tree.setCheckedKeys([]);
                }else{
                  Message({message: '错误提示：'+res.msg,type: 'error'});
                }
          });

      },
      querySystemPermssionByRoleType(){
        authorityApi.querySystemPermssionByRoleType6({
          shopUserGuid: this.shopUserGuid
        }).then(res =>{
                if(res.code == 0){
                  this.treeListData = res.data;
                  this.selectTreeListData = [];
                  this.forEachList(res.data);
                  this.setCheckedNodes(this.selectTreeListData);
                  this.dialogTableVisible1 = true;
                }else{
                    Message({message: '错误提示：'+res.msg,type: 'error'});
                }
          });

      },
      forEachList(res){
        res.forEach(item => {
            item.label = item.permissionName;
            if(item.children == null || item.children.length == 0 && item.checkPermssion == 1){
                this.selectTreeListData.push({
                    label: item.permissionName,
                    guid: item.guid
                });
            }
            if(item.children != null){
                this.forEachList(item.children);
            }
        });
    },
      setCheckedNodes(res) {
        setTimeout(() =>{
          this.$refs.tree.setCheckedNodes(res);
        },100)

    },
      // 选择员工
      changeSelect(){
        if(this.shopUserGuid == ''){
          this.querySystemPermssionByRoleType();
        }else{
          this.querySystemPermssionByRoleType7();
        }

      },
      // 批量添加权限
    addBusUserPermMapList(){
      authorityApi.addBusUserPermMapList({
        shopUserGuid: this.shopUserGuid,
        permissionGuids: this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())
      }).then(res =>{
            // console.log(res)
            if(res.code == 0){
              this.$message.success('设置成功');
              this.dialogTableVisible1 = false;
                this.$router.push({path: '/'}).catch(() =>{});
            }else{
              this.$message.error('错误提示：'+res.msg);

            }
        });
    },
      // queryBusShopUserVoBypage(){
      //   let _this = this;
      //   orgStaffApi.queryBusShopUserVoBypage({
      //     pageSize: 100000,
      //     page: 1
      //   }).then(res =>{
      //     if(res.code == 0){
      //             // console.log(res)
      //             this.shopUserArr = res.data.list;
      //             this.dialogTableVisible1 = true;
      //         }else{
      //             Message({message: '错误提示：'+res.msg,type: 'error'});
      //         }
      //     });

      // },
      onSubMitData(formName){
        let _this = this;
        this.$refs[formName].validate((valid) => {
              if (valid) {
                userApi.updateUserPsw(this.formInline).then(res =>{
                      if(res.code == 0){
                          Message({message: '修改成功',type: 'success'});
                          _this.dialogTableVisible = false;
                          _this.formInline = {
                            oldloginpwd: '',
                            loginpwd: '',
                          }
                      }else{
                          Message({message: '错误提示：'+res.msg,type: 'error'});
                      }
                });
              }else{
                  return false
              }
          })

      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .el-icon-setting{
  color: #000;
 }
 .el-dropdown span{
  color: #000;
 }
 .el-header {
    background-color: #e9eef3;
    line-height: 60px;
  }
  .el-dropdown{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/headNav.vue